export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-amber-900 to-amber-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-3">
            <div className="inline-block px-4 py-1 bg-amber-100 text-amber-900 rounded-full text-sm font-semibold mb-6">
              Our Story
            </div>
            <h2 className="text-5xl md:text-6xl font-serif font-bold text-white mb-8 leading-tight">
              Fresh Ingredients, Family Tradition
            </h2>
            <div className="space-y-6 text-white/85 text-base leading-relaxed">
              <p>
                For over three generations, our family has been dedicated to bringing authentic flavors and warm hospitality to our community. What started as a small neighborhood eatery has grown into a beloved destination for food lovers seeking quality and tradition.
              </p>
              <p>
                We believe that great food begins with great ingredients. That's why we partner with local farmers and suppliers to source the freshest seasonal produce, premium meats, and artisanal products. Every dish is crafted with care, honoring time-tested recipes while embracing modern culinary techniques.
              </p>
              <p>
                Our kitchen is the heart of our restaurant, where passion meets precision. From our signature sauces to our hand-rolled pasta, everything is made from scratch daily. We take pride in creating memorable dining experiences that bring people together around the table.
              </p>
            </div>
            <a href="#contact" className="inline-flex items-center gap-2 mt-8 px-8 py-4 bg-white text-amber-900 rounded-full font-semibold hover:bg-amber-50 transition-all whitespace-nowrap cursor-pointer">
              Learn More About Us
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="md:col-span-2">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20chef%20in%20modern%20restaurant%20kitchen%20preparing%20fresh%20ingredients%20with%20passion%20wearing%20white%20chef%20coat%20focused%20on%20cooking%20warm%20ambient%20lighting%20authentic%20culinary%20craftsmanship%20food%20preparation%20scene%20with%20fresh%20vegetables%20and%20cooking%20utensils%20on%20wooden%20counter&width=600&height=800&seq=about-chef-img&orientation=portrait" 
                alt="Our Chef" 
                className="w-full h-auto rounded-3xl border-2 border-white/20 shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}